export const cacheKey = "/engagement/link_aliases/upsert_lid" as const;
